export default {
    props: {
        messagesWeekColumnHeader: {
            type: String,
            kComposite: 'messages.weekColumnHeader'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoMultiViewCalendar/Messages.js